import DefaultIndividualsFeatureList from './features/defaultIndividualsFeatureList';
import AdvantageAnnualFeatureList from './features/advantageAnnualFeatureList';
import FeatureRules from './rules/featureRules';
import summaryFeaturesTransformer from './summaryFeaturesTransformer';

export default summaryFeaturesTransformer([...DefaultIndividualsFeatureList, ...AdvantageAnnualFeatureList], {
  ...FeatureRules,
  // Add feature rule overrides below
});
